import { render, staticRenderFns } from "./historyemail.vue?vue&type=template&id=3979b604&"
import script from "./historyemail.vue?vue&type=script&lang=js&"
export * from "./historyemail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports